import { render, staticRenderFns } from "./writing-image.vue?vue&type=template&id=72568766&scoped=true&"
import script from "./writing-image.vue?vue&type=script&lang=js&"
export * from "./writing-image.vue?vue&type=script&lang=js&"
import style0 from "./writing-image.vue?vue&type=style&index=0&id=72568766&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72568766",
  null
  
)

export default component.exports